import newsletterConfig from '../../../newsletter-config.json'
import mapNewsletterItems from '../functions/mapNewsletterItems'
import NewsletterContentButton from './NewsletterContentButton'
import NewsletterContentText from './NewsletterContentText'
import { NewsletterSectionRow, TableWrapper, TableWrapperButton } from './helpersComponents'
import { headlineLargeBold, headlineMediumBold, textNormal } from './helpersTypo'
import NewsletterTranslation from './NewsletterTranslation'
import getBackgroundImage from '../functions/getBackgroundImage'

const NewsletterSectionAds = ({id, stylesData, newsletterData, structureItemData, movieData, cinemaData, items, translation}) => {
    const { cinemaUrl, cinemaProgramUrl } = cinemaData
    const chosenFont = stylesData.chosenFont

    const colorHeadline = stylesData.secText
    const colorText = stylesData.mainText

    const colorButton = stylesData.buttonText
    const backgroundButton = stylesData.buttonBackground
    const buttonBorder = stylesData.buttonBorder ? '1px solid ' + stylesData.buttonBorder: false
    const buttonBorderRadius = 0 != stylesData.buttonRadius ? stylesData.buttonRadius : false
    const backgroundButtonGradient = stylesData.buttonGradient ? stylesData.buttonGradient : false

    const imgBorderRadius = stylesData.posterRadius ? stylesData.posterRadius : 0

    const components = []

    return (
        mapNewsletterItems(id, newsletterData, items, (components, itemData, index) => {
            const { imagePoster, movieRefID, link } = itemData
            const hasRefMovie = movieRefID && movieData[movieRefID] 
            const movieRef = hasRefMovie ? movieData[movieRefID] : false

            let title = ''
            let text = ''
            let imageUrl = false
            let imageAlt = <NewsletterTranslation id="print_newsletter_preview_no_alt_text" translation={translation}>Kein alt Text vorhanden</NewsletterTranslation>
            let buttonText = false
            let buttonUrl = false

            if(itemData.title) {
                title = itemData.title
            } else if(hasRefMovie) {
                title = movieRef.titleDisplay ? movieRef.titleDisplay : movieRef.title
            }

            if(title) {
                title = title.toUpperCase()
            }

            if(itemData.text) {
                text = itemData.text
            } else if(hasRefMovie && movieRef.descriptionShort) {
                text = movieRef.descriptionShort
            }

            if(link) {
                if('absolute' === link.pathType ) {
                    buttonUrl = link.url
                } else {
                    const relUrl = '/' === link.url[0] ? link.url.substring(1) : link.url
                    buttonUrl = `${cinemaUrl}${relUrl}`
                 }

                buttonText = link.text.toUpperCase()
            } else if(hasRefMovie) {
                buttonText = <NewsletterTranslation id="print_newsletter_preview_tickets" translation={translation} uppercase={true}>TICKETS</NewsletterTranslation>
                buttonUrl = `${cinemaProgramUrl}?id=${movieRef.id}`
            }

            if(imagePoster) {
                imageUrl = imagePoster.url
                imageAlt = imagePoster.alt
            } else if(hasRefMovie) {
                const { imgUrl, imgAlt } = getBackgroundImage(movieRef)

                imageUrl = imgUrl
                imageAlt = imgAlt ? imgAlt : imageAlt
            }

            const hasStructureHeadline = structureItemData.headlineFront && index === 0

            if(hasStructureHeadline) {
                components.push([
                    <NewsletterSectionRow key={'head'}>
                        <TableWrapper>
                            <tr>
                                <NewsletterContentText style={{paddingTop: "102px", paddingBottom: "34px"}}>
                                    <h4 style={{...{color: colorHeadline, textAlign: "center"}, ...headlineLargeBold(chosenFont)}}>
                                        {structureItemData.headlineFront.toUpperCase()}
                                        {/* <NewsletterTranslation id="print_newsletter_preview_upcoming_events" translation={translation} uppercase={true}>KOMMENDE EVENTS</NewsletterTranslation> */}
                                    </h4>
                                </NewsletterContentText>
                            </tr>
                        </TableWrapper>
                    </NewsletterSectionRow>
                ])
            }

            components.push(
                <NewsletterSectionRow key={index + '-ad'}>
                    <TableWrapper>
                        <tr>
                            <NewsletterContentText style={{paddingTop: hasStructureHeadline ? "0px" : "102px", paddingBottom: "22px"}}>
                                <h4 style={{...{color: colorHeadline, textAlign: "center"}, ...headlineLargeBold(chosenFont)}}>{title}</h4>
                            </NewsletterContentText>
                        </tr>

                        {imageUrl && <tr>
                            <td className="imageContent" align="Left" valign="top">
                                <img className="flexibleImage" alt={imageAlt} src={imageUrl} width={newsletterConfig.bodyWith}  style={{maxWidth: newsletterConfig.bodyWith, height: "auto", borderRadius: imgBorderRadius}}/>
                            </td>
                        </tr>}

                        <tr>
                            <NewsletterContentText style={{...textNormal(chosenFont), ...{color: colorText, textAlign: "center", paddingTop: text ? "19px" : "0px", paddingBottom: buttonText && buttonUrl && text ? "10px" : buttonText && buttonUrl ? "15px" : "0px"}}}>
                                {text}
                            </NewsletterContentText>
                        </tr>
                    </TableWrapper>

                </NewsletterSectionRow>,

                buttonText && buttonUrl && <NewsletterSectionRow key={index + '-button'}>
                    <TableWrapperButton width={newsletterConfig.linkButtonWidth} background={backgroundButton} backgroundGradient={backgroundButtonGradient} border={buttonBorder} borderRadius={buttonBorderRadius}>
                        <NewsletterContentButton
                            text={buttonText}
                            url={buttonUrl}
                            color={colorButton}
                            textStyles={headlineMediumBold(chosenFont)}
                        />
                    </TableWrapperButton>
                </NewsletterSectionRow>
            )
        }, components)
    )
}

export default NewsletterSectionAds

